<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'
  import { Button, type ButtonVariants } from '../button'

  /**
   * The trailing action of a `ComboboxHeader` (e.g. "Manage"), built on the
   * `Button` primitive so it inherits focus-ring / disabled handling. Styled as
   * a compact, muted text action that sits flush in the header row — defaults
   * to the borderless `link` variant. Native listeners (`@click`) and
   * `disabled` fall through to the underlying button.
   */
  const props = withDefaults(
    defineProps<{
      variant?: ButtonVariants['variant']
      disabled?: boolean
      dataTestid?: string
      class?: HTMLAttributes['class']
    }>(),
    {
      variant: 'link'
    }
  )
</script>

<template>
  <Button
    type="button"
    :variant="variant"
    size="sm"
    :disabled="disabled"
    :data-testid="dataTestid"
    :class="
      cn(
        'text-muted-foreground hover:text-foreground h-auto px-0 font-medium no-underline hover:no-underline',
        props.class
      )
    "
  >
    <slot />
  </Button>
</template>
